module.exports = __webpack_public_path__ + "static/media/fdi_logo.a09bd965.png";